import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translation from '../locales/es-CL/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'es-CL': {
        translation,
      },
    },
    lng: 'es-CL',
    fallbackLng: 'es-CL',
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;















